import { ENRICHMENT_CATEGORY_TYPE_PROFILE, ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE, ENRICHMENT_CATEGORY_TYPE_VOTE } from 'common-data-handling';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import urlparam from 'urlparam';
import WaitWhileBusy from '../../WaitWhileBusy';
import EnrichmentsHomeAlreadyVoted from './EnrichmentsHomeAlreadyVoted';
import EnrichmentsHomeIntroduction from './EnrichmentsHomeIntroduction';
import EnrichmentsHomeListQuestions from './EnrichmentsHomeListQuestions';
import EnrichmentsHomeVoteLater from './EnrichmentsHomeVoteLater';
import HasEnrichmentCategory from './common/HasEnrichmentCategory';
import enrichmentsConnect from './common/connectEnrichments';

class EnrichmentsHome extends React.Component {
    componentDidMount() {
        this.props.notifications.forEach(notif => {
            app.api.notifications.markRead(notif.id);
        });
    }
    render() {
        let {event} = this.props,
            props = {
                ...this.props,
                returnURL: event.open_required_enrichments_count ? '/' : '../..',
            };

        if (urlparam('autostart', false)) {
            let question = props.questions[0];
            if (question) {
                return <Redirect to={app.history.location.pathname + '/question/' + question.id} />;
            }
        }

        switch (props.cat) {
            case ENRICHMENT_CATEGORY_TYPE_VOTE:
                if (!props.questions.length) {
                    return <EnrichmentsHomeVoteLater {...props} />;
                } else if (props.allQuestionsAnswered) {
                    return <EnrichmentsHomeAlreadyVoted {...props} />;
                } else {
                    return <EnrichmentsHomeIntroduction {...props} />;
                }
                break;
            case ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE:
                if (!props.questions.length) {
                    return <EnrichmentsHomeVoteLater {...props} />;
                } else if (props.noQuestionsAnswered) {
                    return <EnrichmentsHomeIntroduction {...props} />;
                } else {
                    return <EnrichmentsHomeListQuestions {...props} />;
                }
                break;
            default:
                return <EnrichmentsHomeListQuestions {...props} />;
        }
    }
}

const EnrichmentsHomeConnected = connect(enrichmentsConnect)(EnrichmentsHome);

export default props => (
    <WaitWhileBusy>
        <HasEnrichmentCategory {...props.match.params} ignore={[ENRICHMENT_CATEGORY_TYPE_PROFILE]}>
            <EnrichmentsHomeConnected {...props.match.params} cat={parseInt(props.match.params.cat)} returnURL={'../..'} />
        </HasEnrichmentCategory>
    </WaitWhileBusy>
);
